import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, TextValues, Control } from './south-carolina-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';
import { RequestService } from '../../../_services/request/request.service';
import { LimitType } from '../../../config/constants';

@Component({
  selector: 'app-south-carolina',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './south-carolina.component.html',
  styleUrl: './south-carolina.component.scss',
  host: {
    class: 'state-wrapper',
  },
})
export class SouthCarolinaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('south-carolina', form);
    } else {
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('south-carolina', null);
    } else {
    }
  }
  constructor(private requestService: RequestService) {
    super();
  }
  /**Changes for premium mapping */
   protected override getLookupControlName(
    control: Control,
  ): string | undefined {
    const isUIM = control.formControlName.includes('UIM');
    const umdropdown = 'UMCombinedSingleLimit_DropDown';
    const uimdropdown = 'UIMCombinedSingleLimit_DropDown';
    return isUIM ? uimdropdown : umdropdown;
  }
 
  override setupHookForDropDownData(){
    this.setupHookForLiabilityDropDownData();
  }
}
